import {
  IClearMyQuestionnaireAction,
  IGetMyQuestionnaireAction,
  IGetMyQuestionnaireActionFulfilled,
  IGetMyQuestionnaireActionRejected,
  IMyQuestionnaireReduxState,
  IRefetchMyQuestionnaireAction
} from "../../types";

const initialState: IMyQuestionnaireReduxState = {
  completed: true,
  error: null,
  pending: false,
  questionnaire: null,
  rejected: false
};

type Action =
  | IGetMyQuestionnaireAction
  | IGetMyQuestionnaireActionFulfilled
  | IGetMyQuestionnaireActionRejected
  | IClearMyQuestionnaireAction
  | IRefetchMyQuestionnaireAction;

export default (state = initialState, action: Action): IMyQuestionnaireReduxState => {
  switch (action.type) {
    case "CLEAR_MY_QUESTIONNAIRE":
      return {
        ...state,
        completed: false,
        error: null,
        pending: false,
        questionnaire: null,
        rejected: false
      };
    case "GET_MY_QUESTIONNAIRE_REJECTED":
      const { e } = action.payload;
      return {
        ...state,
        completed: true,
        error: e,
        pending: false,
        questionnaire: null,
        rejected: true
      };
    case "GET_MY_QUESTIONNAIRE":
      return {
        ...state,
        completed: false,
        error: null,
        pending: true,
        questionnaire: null,
        rejected: false
      };
    case "GET_MY_QUESTIONNAIRE_FULFILLED":
      return {
        ...state,
        completed: true,
        error: null,
        pending: false,
        questionnaire: action.payload,
        rejected: false
      };
    default:
      return state;
  }
};
